export default __webpack_public_path__ + "static/media/photo--sm--misc-1.09b720ca.jpg";